import { LayoutField, LayoutFieldType } from "./LayoutFieldType";
import { TLiteral, TRecord, Type } from "@sinclair/typebox";
import { TypeBoxToType } from "./TypeBoxToType";

export const LAYOUT_FIELDS_SETUP_NAMES_ARRAY = [
  "lead",
  "newLead",
  "contact",
  "newContact",
  "account",
  "newAccount",
  "newActivity",
  "newTask",
  "newCase",
  "newEvent",
  "user",
  "manager",
  "wapTask",
  "task",
  "activity",
  "case",
  "opportunity",
  "event",
  "newPersonAccount",
  "personAccount",
] as const;

export const LayoutFieldsSetupBaseNames = Type.Union(LAYOUT_FIELDS_SETUP_NAMES_ARRAY.map((layoutKey) => Type.Literal(layoutKey)));
export type LayoutFieldsSetupBaseNamesType = TypeBoxToType<typeof LayoutFieldsSetupBaseNames>;

export const LayoutFieldsSetupNames = Type.Union([LayoutFieldsSetupBaseNames, Type.String()]) as unknown as TLiteral<LayoutFieldsSetupNamesType>;
export type LayoutFieldsSetupNamesType =
  | LayoutFieldsSetupBaseNamesType
  | `${LayoutFieldsSetupBaseNamesType}:${string}`
  | `${LayoutFieldsSetupBaseNamesType}:${string}:${string}`;

// This can only be used for typing not for validation
const y = Type.Array(LayoutField);
export const LayoutFieldsSetup = Type.Record(Type.String(), y) as unknown as TRecord<TLiteral<LayoutFieldsSetupNamesType>, typeof y>;
export type LayoutFieldsSetupType = Record<LayoutFieldsSetupNamesType, LayoutFieldType[]>;
